import { SET_MESSAGE, CLEAR_MESSAGE } from "./constant";

export const setMessage = (title, content) => ({
  type: SET_MESSAGE,
  title,
  content
});

export const clearMessage = () => ({
  type: CLEAR_MESSAGE
});
